export * from '@primeuix/themes/material/avatar';
export { default } from '@primeuix/themes/material/avatar';
